import React, {createRef} from 'react';

import Icon from './Icon';

class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: this.props.toggle || false,
            mouseInPerimeter: false,
        };
        this.ref = createRef();
        this.handleToggleDropdown = this.handleToggleDropdown.bind(this);
        this.handleCloseDropdown = this.handleCloseDropdown.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    handleMouseEnter() {
        this.setState({mouseInPerimeter: true});
    }

    handleMouseLeave() {
        this.setState({mouseInPerimeter: false});
    }

    handleToggleDropdown() {
        this.setState({toggle: !this.state.toggle});
        if (typeof this.props.handleToggleChildren == "function") {
            this.props.handleToggleChildren(!this.state.toggle);
        }
        if (this.props.type === 'chat') {
            this.props.handleEmojiVisibility(this.state.toggle);
        }
    }

    handleCloseDropdown(e) {
        let eventTargetIsOutside = this.ref && !this.ref.contains(e.relatedTarget) && !!this.props.closeOnClick;
        if (!this.state.mouseInPerimeter || eventTargetIsOutside) {
            this.setState({toggle: false});
            if (typeof this.props.handleToggleChildren == "function") {
                this.props.handleToggleChildren(false);
            }
            if (this.props.type === 'chat') {
                this.props.handleEmojiVisibility(this.state.toggle);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.toggle !== this.props.toggle) {
            this.setState({toggle: nextProps.toggle});
        }
        if (nextProps.toggleStatus !== this.props.toggleStatus) {
            this.setState({toggle: nextProps.toggleStatus});
        }
    }

    render() {
        return (
            <div
                className={`dropdown ${this.props.className || ""} ${this.state.toggle && this.props.classNameActive ?this.props.classNameActive : "" }`}
                tabIndex="0"
                ref={ref=>{this.ref = ref}}
                onBlur={(e) => this.handleCloseDropdown(e)}
            >
                <div className={`dropdown-children ${(this.state.toggle) && 'active'}`}
                     onClick={() => this.handleToggleDropdown()}>
                    {this.props.activableComponent}
                </div>
                {this.state.toggle && (
                    <div className={`dropdown-relatif ${this.props.align || ""}`}
                         onMouseEnter={() => this.handleMouseEnter()}
                         onMouseLeave={() => this.handleMouseLeave()}>
                        <Icon type="caret-up"/>
                        <div className="dropdown-content">
                            {this.props.children}
                            <span className="close-dropdown" onClick={() => this.handleToggleDropdown()}>Fermer</span>
                        </div>
                        {this.props.type !== "chat" &&
                        <div className="layer" onClick={() => this.handleToggleDropdown()}></div>}
                    </div>
                )}
            </div>
        )
    }
}

export default Dropdown;
